<template>
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-flex>
                <h2 class="pr-3">{{ $t('menu.groups') }}</h2>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex sm6 md3>
                <v-text-field
                  @input="searchGroups"
                  :label="$t('action.search')"
                  v-model="search"
                  clearable
                  clear-icon="close"
                  append-icon="search"
                  :loading="searching"
                ></v-text-field>
            </v-flex>
            <!--<v-flex sm6 md3>-->
            <!--<v-select-->
            <!--@input="searchRegistrations"-->
            <!--v-model="registration_list.params.payment_status"-->
            <!--:items="payment_status_items"-->
            <!--item-text="text"-->
            <!--item-value="value"-->
            <!--:label="$t('deposit_transaction.payment_status')"-->
            <!--multiple-->
            <!--clearable-->
            <!--:loading="registration_list.searching"-->
            <!--&gt;</v-select>-->
            <!--</v-flex>-->
        </v-layout>
        <v-layout row wrap>
            <template v-for="(item, i) in items">
                <v-flex
                  xs12 sm6 md4
                  :key="i"
                  @click="editItem(item)"
                >
                    <v-card style="cursor: pointer;">
                        <v-card-title primary-title style="padding: 0;">
                            <v-flex xs3>
                                <v-icon x-large>people</v-icon>
                            </v-flex>
                            <v-flex xs6>
                                <div>
                                    <div class="font-weight-bold">{{item.name}}</div>
                                    <div>{{$t('contact.n_contacts', [item.contacts.length])}}</div>
                                </div>
                            </v-flex>
                            <v-flex xs3 class="text-xs-right"
                                @click.prevent.stop="item.showMenu = true"
                            >
                                <v-menu v-model="item.showMenu" bottom left>
                                    <v-btn
                                      slot="activator"
                                      icon
                                    >
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>

                                    <v-list>
                                        <v-list-tile
                                          @click="deleteItem(item)"
                                        >
                                            <v-list-tile-title>{{$t('action.delete')}}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </template>
            <v-btn
              color="primary"
              dark
              fab
              absolute
              bottom
              right
              @click="showNewForm"
              class="mb-5"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-layout>

        <div class="text-xs-center">
            <v-progress-circular v-show="loading" color="grey" :indeterminate="true"></v-progress-circular>
        </div>

        <group-edit-dialog
            v-model="editForm.show"
            :item="editForm.item"
            @success="editSuccess"
            @addContactsCallback="addContactsCallback"
            @deleteContactCallback="deleteContactCallback"
        >

        </group-edit-dialog>
    </v-container>
</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from "~/utils/url-manager";
    import i18n from "~/i18n";
    import FormHandling from '~/utils/data/form-handling'
    import formatter from '~/utils/formatter'
    import GroupEditDialog from '~/components/contact/GroupEditDialog.vue'
    import ExcelReader from '~/utils/excel-reader'
    import importMixin from './import-mixin'
    import { CancelToken } from 'axios'
    export default {
        components: {
            GroupEditDialog
        },
        mixins: [importMixin],
        data () {
            return {
                loading: false,
                bottomReached: false,
                page: 1,
                items: [],
                actions: [i18n.t('action.edit'), i18n.t('action.delete')],
                editForm: {
                    action: UrlServices.createUrl({'name': 'api_contact_group_save'}),
                    show: false,
                    item: {
                        name: '',
                        contacts: []
                    },
                    rules: {
                        required: value => !!value || this.$t('form.field_required')
                    },
                    errors: {
                        name: ''
                    }
                },
                contactsDialog: {
                    show: false,
                    bottomReached: false,
                    page: 1,
                    loading: false,
                    title: i18n.t('menu.contacts'),
                    group: {},
                    contacts: []
                },
                uploadDialog: {
                    show: false,
                    group: {}
                },
                search: '',
                searching: false,
                cancel: () => {}
            }
        },
        methods: {
            reload() {
                this.page = 1;
                this.items = [];
                this.bottomReached = false;
                this.getGroups();
            },
            getGroups(search) {
                let me = this;
                me.loading = true;
                let config = {
                    cancelToken: new CancelToken(function executor(c) {
                        me.cancel = c;
                    })
                };
                let params = {
                    page: me.page,
                    search: search
                };
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_contact_group_list'}), params, {
                    'success': function (data) {
                        // me.items = data.data;
                        // me.items.map(x => {
                        //     x.showMenu = false;
                        //     x.contacts.map(c => {
                        //         formatter.parsePhone(c);
                        //     });
                        // });
                        _.each(data.data, x => {
                            x.showMenu = false;
                            x.contacts.map(c => {
                                formatter.parsePhone(c);
                            });
                            me.items.push(x);
                        });

                        me.loading = false;
                        me.searching = false;
                        if (me.page < data.total_page) {
                            me.bottomReached = false;
                        }
                        me.page++;
                    }
                }, config);
            },
            searchGroups: _.debounce(function(search) {
                this.cancel();
                this.page = 1;
                this.searching = true;
                this.items = [];
                this.$nextTick(function() {
                    this.getGroups(search);
                });
            }, 500),
            showNewForm() {
                this.editForm.item = {
                    //id: 0,
                    name: '',
                    contacts: []
                };
                this.editForm.loading = false;
                this.editForm.show = true;
            },
            editItem(item) {
                //console.log('editItem', item);
                item.showMenu = false;
                this.editForm.item = _.extend({}, item);    // Create a object to temporarily store the changes
                this.editForm.show = true;
            },
            editSuccess(data) {
                //console.log('editSuccess', data);

                let item = _.find(this.items, x => {
                    return x.id === data.id;
                });

                if (item) {
                    item.name = data.name;
                } else {
                    item = {
                        id: data.id,
                        name: data.name,
                        contacts: [],
                        showMenu: false
                    };
                    this.items.push(item);
                }

                this.editForm.show = false;
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: this.$t('app.msg_edit_success'),
                    timeout: 3000
                };
            },
            deleteContactCallback(group_id, new_contact_ids) {
                let item = _.find(this.items, x => {
                    return x.id === group_id;
                });

                item.contacts = [].concat(new_contact_ids);
            },
            addContactsCallback(data, selectedContacts) {
                let item = _.find(this.items, x => {
                    return x.id === data.id;
                });
                if (item) {
                    item.contacts = [].concat(item.contacts, selectedContacts);
                } else {
                    item = {
                        id: data.id,
                        name: data.name,
                        contacts: selectedContacts,
                        showMenu: false
                    };
                    this.items.push(item);
                }
            },
            deleteItem(item) {
                //console.log('deleteItem', item);
                item.showMenu = false;
                let me = this;
                RequestHandler.Post(UrlServices.createUrl({'name': 'api_contact_group_delete'}), {id: item.id}, {
                    'success': function(data){
                        //console.log(data);
                        me.items = _.filter(me.items, x => {
                            return x.id !== item.id;
                        });

                        me.editForm.show = false;
                        getApp.snackbar = {
                            show: true,
                            color: 'green',
                            text: me.$t('app.msg_delete_success'),
                            timeout: 3000
                        };
                    }
                });
            },
            onScroll() {
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                    // you're at the bottom of the page
                    if (!this.bottomReached) {
                        this.bottomReached = true;
                        this.getGroups();
                    }
                }
            }
        },
        mounted() {
            this.getGroups();
        }
    }
</script>

<style scoped>
    #editForm {
        width: 100%;
    }
    .full-height {
        height: 100%;
    }
</style>